module.exports = __webpack_public_path__ + "img/ct_bru-anatomy.981d849f.jpg";